import React, { Component, useState, useEffect } from "react";
import { DropIcon, MenuIcon } from "core/components/svgIcon";
import { toast } from "react-toastify";
import _ from "lodash";
import { useModal } from "core/hooks/modalHook";
import { ReportChartModal } from "../reportChartModal";
import { NodeModal } from "../nodeModal";
import { CarouselV2, CarouselV2Slide } from "core/components/carouselv2";
import { NodeCardV2Avatar } from "./nodeCardV2__avatar";
import { SettingsIcon } from "core/components/svgIcon";
import SettingsModal from "../settingsModal";
import { AlertIcon } from "core/components/svgIcon";
import { AlertsIcon } from "core/components/svgIcon";
import { AlertModal } from "../alertModal";
// import { DiagnosticModal } from "../diagnosticModal";

const SettingIcon = ({ width = "1.6rem", height = "1.6rem" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 1 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 1 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const BellIcon = ({ width = "1.6rem", height = "1.6rem" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M6 8a6 6 0 0 1 12 0c0 7 3 9 3 9H3s3-2 3-9" />
    <path d="M10.3 21a1.94 1.94 0 0 0 3.4 0" />
  </svg>
);

const ReportsIcon = ({ width = "1.6rem", height = "1.6rem" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M3 3v18h18" />
    <path d="M18 17V9" />
    <path d="M13 17V5" />
    <path d="M8 17v-3" />
  </svg>
);

const EnlargeIcon = ({ width = "1.4rem", height = "1.4rem" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 3 21 3 21 9" />
    <polyline points="9 21 3 21 3 15" />
    <line x1="21" x2="14" y1="3" y2="10" />
    <line x1="3" x2="10" y1="21" y2="14" />
  </svg>
);

const HeartIcon = ({ width = "1.6rem", height = "1.6rem", message }) => (
  <svg width={width} height={height} viewBox="0 0 24 24">
    {message ? <title>{message}</title> : null}
    <path d="M12 21s-7-4.35-9.5-9A5.5 5.5 0 0 1 12 5.5 5.5 5.5 0 0 1 21.5 12c-2.5 4.65-9.5 9-9.5 9z" />
  </svg>
);

const ParameterValue = ({ name, unit, value = 0 }) => {
  return (
    <div className="reading">
      <p className="reading__name is-text-primary is-size-6 is-uppercase">
        {name}
      </p>
      <p className="reading__value is-text-light is-size-6 has-text-centered">
        {value} <b>{unit}</b>
      </p>
    </div>
  );
};

function getDate() {
  const today = new Date();
  const month = today.getMonth() + 1;
  const date = today.getDate();
  return `${date}-${month}`;
}

export const NodeCardV2 = (props) => {
  // To be checked
  const [currentDate, setCurrentDate] = useState(getDate());
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTime(new Date());
    }, 1000); // Update every second

    // Cleanup the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []); // Empty dependency array ensures the effect runs only once

  const hours = time.getHours();
  const minutes = time.getMinutes();

  // Format the time as we need (e.g., add leading zeros)
  const formattedTime = `${hours}:${minutes < 10 ? "0" : ""}${minutes}`;

  // Ends Here

  const { node, liveReading } = props;
  const { parameters, diagnosticParameters, site, nodeType, tagName } = node;
  let paramLength = 3;
  const paramSize = _.size(parameters);
  if (paramSize >= 16) {
    paramLength = 8;
  }
  const [readingMap, setReadingMap] = useState({});
  useEffect(() => {
    const fetchData = () => {
      try {
        const { parameterValues, epochTime } = liveReading;
        let copy = { ...readingMap };
        _.forEach(parameterValues, function (value) {
          copy[value["identifier"]] = _.round(value["processedValue"], 3);
        });
        setReadingMap({ ...copy });
        setHeartBeatColour(epochTime);
      } catch (ex) {
        console.log(ex);
        toast.error("Error while fetching data");
      }
    };
    if (liveReading) {
      fetchData();
    }
  }, [liveReading]);

  const [heartbeatClass, setHeartbeatClass] = useState("fill-green");
  const [message, setMessage] = useState();
  const setHeartBeatColour = (epochTime) => {
    let fifteenMinutes = 15 * 60 * 1000;
    let fourHours = 4 * 60 * 60 * 1000;
    let datetime = Date.now() - epochTime * 1000;

    if (datetime < fifteenMinutes) {
      setHeartbeatClass("fill-green");
      setMessage("Online");
    } else if (fifteenMinutes <= datetime && datetime <= fourHours) {
      setHeartbeatClass("fill-yellow");
      setMessage("Delayed");
    } else if (datetime > fourHours) {
      setHeartbeatClass("fill-red");
      setMessage("Offline");
    }
  };

  const [nodeModal, openNodeModal, closeNodeModal] = useModal(false);
  const [settingsModal, openSettingsModal, closeSettingsModal] = useModal(false);
  const [alertModal, openAlertModal, closeAlertModal] = useModal(false);


  // const handleOpenNodeDetailsModal = () => {
  //   openNodeModal();
  // };

  // const [diagnosticModal, openDiagnosticModal, closeDiagnosticModal] =
  //   useModal(false);
  // const handleOpenDiagnosticModal = () => {
  //   if (diagnosticParameters && diagnosticParameters.length > 0) {
  //     openDiagnosticModal();
  //   } else {
  //     toast.warn("Diagnostic data not available for this node");
  //   }
  // };

  const [chart, openChart, closeChart] = useModal(false);
  const handleOpenChartModal = () => {
    openChart();
  };

  const slides = [];
  let columnList = [];
  _.each(parameters, function (parameter, i) {
    if (i % paramLength == 0 && i != 0) {
      let slideContainer = (
        <CarouselV2Slide cssClasses="px-2">
          <div className="columns is-gapless is-multiline">{columnList}</div>
        </CarouselV2Slide>
      );
      slides.push(slideContainer);
      columnList = [];
    }
    columnList.push(
      <div className="column is-full" key={i}>
        <ParameterValue
          name={parameter.name}
          unit={parameter.unit}
          value={readingMap[parameter.identifier]}
        />
      </div>
    );
  });
  if (_.size(columnList) > 0) {
    let slideContainer = (
      <CarouselV2Slide cssClasses="px-4">
        <div className="columns is-gapless is-multiline">{columnList}</div>
      </CarouselV2Slide>
    );
    slides.push(slideContainer);
  }

  const tagNameClass =
    _.size(tagName) < 20 && _.size(nodeType) < 20 ? "is-4" : "is-6";
  const nodeTypeClass =
    _.size(tagName) < 20 && _.size(nodeType) < 20 ? "is-5" : "is-6";

  return (
    <React.Fragment>
      <div className="node-card-v2 node-card-v2--short">
        <div className="node-card-v2__header is-red">
          {/* cards main icon section part */}

          <div className="node-card-v2__header__1 is-clearfix">
            {/* icons section of card started*/}
            <ul className="icons-section pull-right">
              <span className="is-pointer settings_icon" onClick={openSettingsModal}>
                <SettingIcon height="1.6rem" width="1.6rem" />
              </span>
              <span className="is-pointer alert_icon" onClick={openAlertModal}>
                <BellIcon height="1.6rem" width="1.6rem" />
              </span>
              <span className="is-pointer reports_icon" onClick={handleOpenChartModal}>
                <ReportsIcon height="1.6rem" width="1.6rem" />
              </span>
              <span className={`heart_icon ${heartbeatClass}`}>
                <HeartIcon height="1.6rem" width="1.6rem" message={message} />
              </span>

              <span className="is-pointer" id="icon-enlarge" onClick={openNodeModal}>
                <EnlargeIcon height="1.4rem" width="1.4rem" />
              </span>
            </ul>
            {/* icons section of card ended*/}
          </div>
          {/* /.node-card-v2__header_1 */}
          <div className="node-card-v2__avatar">
            <div className="node-card-v2__avatar__image">
              <NodeCardV2Avatar nodeType={nodeType} />
            </div>
          </div>
          <div className="node-card-v2__header-content">
            <p className={`title ${tagNameClass}`}>{tagName}</p>
            <p className={`subtitle ${nodeTypeClass}`}>{nodeType}</p>
          </div>
        </div>
        {/* /.node-card-v2__header */}

        <div className="node-card-v2__content">
          <CarouselV2 slides={slides} />
        </div>
      </div>
      {/* /.node-card-v2 */}
      <div>
        <ReportChartModal open={chart} onClose={closeChart} node={node} />
      </div>
      {nodeModal ? (
        <div>
          <NodeModal
            open={nodeModal}
            onClose={closeNodeModal}
            node={node}
            liveReading={liveReading}
            site={site}
          />
        </div>
      ) : (
        ""
      )}
      {settingsModal ? (
        <div>
          <SettingsModal
            open={settingsModal}
            onClose={closeSettingsModal}
            parameterNames={parameters}
            nodeId={node.id}
          />
        </div>
      ) : (
        ""
      )}
      {alertModal ? (
        <div>
          <AlertModal
            open={alertModal}
            onClose={closeAlertModal}
            nodeId={node.id}
            tagName={tagName}
            nodeType={nodeType}

          />
        </div>
      ) : (
        ""
      )}
    </React.Fragment>
  );
};
